<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddMechanic</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>

        <div class="card auto">
          <div class="card-content">


            <div class="card pad15">
              <div class="row">
                  <div class="col-md-3 ">
                      <div class="input-group">
                          <input class="form-control" [(ngModel)]="searchString" placeholder="{{ 'lblSearch' | translate }}">
                          <div class="input-group-append">
                              <button type="button" aria-label="Center Align" class="btn btn-primary" [disabled]="searchString.length == 0" translate (click)="SearchEmployee(true)">
                                  <em aria-hidden="true" class="fa fa-search"></em>
                              </button>
                          </div>
                      </div>
                  </div>
                  <div class="col-auto pl-0">
                    <button class="btn btn-primary" aria-label="Center Align"  translate (click)="ClearEmployee()" [disabled]="searchString.length == 0">lblClear</button>
                  </div>
                 </div>
            </div>


 

            <div class="card-body scrollbar user">


              <div class="card pad15 mb-3" *ngIf="isSearched">

                <div class="card-header d-flex  justify-content-between">
                  <h4 class="card-title" translate>lblEmployeeList</h4>
                  <div class="font16 fontbold">
                    <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                    totalCount
                    }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                  </div>
                </div>

                  <div class="table-responsive max-h254"
                                infinite-scroll
                                [infiniteScrollDistance]="scrollDistance"
                                [infiniteScrollThrottle]="throttle"
                                [scrollWindow]="false"
                                (scrolled)="onScrollDown($event)">
                  <table class="tablest1">
                    <thead>
                      <tr>
                        <th style="width: 10%" scope="col">#</th>
                        <th style="width: 20%" scope="col"><span translate>lblName</span></th>
                        <th style="width: 15%" scope="col" translate>lblEmail</th>
                        <th style="width: 10%" scope="col" translate>lblMobile</th>
                        <th style="width: 15%" scope="col" *ngIf="!areCodesHidden" translate>lblDealershipsId</th>
                        <th style="width: 15%" scope="col" *ngIf="!areCodesHidden" translate>lblFunctionCode</th>
                        <th style="width: 20%" scope="col" translate>lblADEmail</th>
                        <th style="width: 10%" scope="col" translate>lblRole</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="employeeList?.length>0; else load_else">
                        <tr *ngFor="let user of employeeList; let i=index">
                          <td>
                            <input type="radio" name="list" class="radio-custom" [ngStyle]="{'background-color': user.isAddedAsUser ? '#d3d3d3' :  null }" [disabled]="user.isAddedAsUser" value="{{user.id}}" (change)="OpenAddMechanicForm(mymodal,user)" />
                          </td>
                          <td>
                            {{user.firstName}} {{user.lastName}}
                          </td>
                          <td>
                            {{user.email}}
                          </td>
                          <td>
                            {{user.phoneNo}}
                          </td>
                          <td *ngIf="!areCodesHidden">
                            <span *ngIf="user.locationCode">
                            {{user.locationCode}} - {{user.locationName}}
                          </span>
                          </td>
                          <td *ngIf="!areCodesHidden">
                            <span *ngIf="user.functionCode">
                            {{user.functionCode}} - {{user.functionCodeDescription}}
                          </span>
                          </td>
                          <td>
                            {{user.adEmail}}
                          </td>
                          <td>
                            {{user.groupRoleName}}
                          </td>
                        </tr>
                      </ng-container>
                      <ng-template #load_else>
                        <tr>
                          <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
              </div>
              <ng-template #mymodal let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" translate>lblMechanicDetail</h4>
                    <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
                        (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="">
              <form [formGroup]="addmechanicForm" (ngSubmit)="AddMechanic()" *ngIf="addMechanic && employeeList?.length>0">
              <div class="card mb15 pad15 border">
                  <div class="form-row">
                    <!--Dealer Id-->
                    <div class="col-4 af-form-group">
                      <label for="template-edit-dealerId" translate>lblSelectDealer<strong class="mlt6 required"> * </strong>
                      </label>
                      <div class='lbl-info'>
                        <ng-select formControlName="dealerName" placeholder="{{ 'lblSelectDealer' | translate }}" [(ngModel)]="dealer"
                          (change)="onDealerSelected($event)" [readonly]="dealer && service.isEdit? true:false">
                          <ng-option *ngFor="let item of dealerList" [value]="item.value">
                            {{item.text}}</ng-option>
                        </ng-select>
                        <div *ngIf="cpf.dealerName.invalid && (cpf.dealerName.dirty || cpf.dealerName.touched)"
                          class="help-block text-danger">
                          <div *ngIf="cpf.dealerName.errors.required"><span translate>lblDealerRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--Name-->
                    <div class="col-4 af-form-group">
                      <label for="template-edit-name" translate>lblName <strong class="mlt6 required"> * </strong>
                      </label>
                      <div class='lbl-info'>
                        <input type="text" id="template-edit-name" name="name" formControlName="name" class="form-control"
                          placeholder="{{ 'lblEnterName' | translate }}" required maxlength="30"
                          [ngClass]="{'is-invalid':cpf.name.invalid && cpf.name.touched}">
                        <div *ngIf="cpf.name.invalid && (cpf.name.dirty || cpf.name.touched)" class="help-block text-danger">
                          <div *ngIf="cpf.name.errors.required"><span translate>lblNameRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--Employee number-->
                    <div class="col-4 af-form-group">
                      <label for="template-edit-employeeNo" translate>lblEmployeeNumber<strong class="mlt6 required"> * </strong>
                      </label>
                      <div class='lbl-info'>
                        <input type="text" id="template-edit-employeeNo" name="employeeNo" formControlName="employeeNo"
                          class="form-control" required maxlength="30" placeholder="{{ 'lblEnterEmployeeNo' | translate }}"
                          [ngClass]="{'is-invalid': cpf.employeeNo.invalid && cpf.employeeNo.touched}">
                        <div *ngIf="cpf.employeeNo.invalid && (cpf.employeeNo.dirty || cpf.employeeNo.touched)"
                          class="help-block text-danger">
                          <div *ngIf="cpf.employeeNo.errors.required"><span translate>lblEmployeeNumberRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--Dms Mechanic No-->
                    <div class="col-4 af-form-group" *ngIf="isDmsMechanicIdUsed">
                      <label for="template-edit-dmsMechanicNo" translate>lblDmsMechanicId<strong class="mlt6 required"> * </strong>
                      </label>
                      <div class='lbl-info'>
                        <input type="text" id="template-edit-dmsMechanicNo" name="dmsMechanicNo" formControlName="dmsMechanicNo"
                          class="form-control" required maxlength="30" placeholder="{{ 'lblEnterDmsMechanicId' | translate }}"
                          [ngClass]="{'is-invalid': cpf.dmsMechanicNo.invalid && cpf.dmsMechanicNo.touched}">
                        <div *ngIf="cpf.dmsMechanicNo.invalid && (cpf.dmsMechanicNo.dirty || cpf.dmsMechanicNo.touched)"
                          class="help-block text-danger">
                          <div *ngIf="cpf.dmsMechanicNo.errors.required"><span translate>lblDmsMechanicIdRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--adUserId -->
                    <div class="col-4 af-form-group">
                      <label for="template-edit-emailId" translate>lblADGUID<strong class="mlt6 required"> * </strong>
                      </label>
                      <div class='lbl-info'>
                        <input type="text" id="template-edit-adUserId " name="adUserId" formControlName="adUserId" class="form-control"
                          required maxlength="50" placeholder="{{ 'lblEnterADGUID' | translate }}"
                          [ngClass]="{'is-invalid': cpf.adUserId .invalid && cpf.adUserId .touched}">
                        <div *ngIf="cpf.adUserId .invalid && (cpf.adUserId .dirty || cpf.adUserId .touched)"
                          class="help-block text-danger">
                          <div *ngIf="cpf.adUserId .errors.required"><span translate>lblADGUIDRequire</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--adEmailId -->
                    <div class="col-md-4 af-form-group">
                      <label for="ADUSerId"><span translate>lblADEmail</span> <span class="text-danger"> * </span>
                      </label>
                      <div class="lbl-info">
                          <input formControlName="adEmail" id="adEmail" class="form-control mb-2"
                              [ngClass]="{'is-invalid': (cpf.adEmail.touched || cpf.adEmail.dirty) && cpf.adEmail.errors}"
                              placeholder="{{ 'lblEnterADEmail' | translate }}" maxlength="36">
                          <div *ngIf="(cpf.adEmail.touched || cpf.adEmail.dirty) && cpf.adEmail.errors">
                              <div *ngIf="cpf.adEmail.errors.required" class="help-block mt-1 text-danger" translate>
                                  lblADEmailRequired
                              </div>
                              <div *ngIf="cpf.adEmail.errors.pattern" class="help-block mt-1 text-danger" translate>
                                  lblEnterValidADEmail
                              </div>
                          </div>
                      </div>
                  </div>

                    <!--IsActive-->
                    <div class="col-4 af-form-group">
                      <label>&nbsp;</label>
                      <div class="lbl-info">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                          <label class="custom-control-label" for="isActive" translate>lblActive</label>
                        </div>
                      </div>
                    </div>

                    <div class="col-4 af-form-group">
                      <label>&nbsp;</label>
                      <div class="lbl-info">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="capacityPlanning" formControlName="capacityPlanning">
                          <label class="custom-control-label" for="capacityPlanning" translate>lblCapacityPlanning</label>
                        </div>
                      </div>
                    </div>

                    <!-- Consider Customer Waiting Slots -->
                    <div class="col-4 af-form-group" *ngIf="isCustomerWaitingSlotsEnabled">
                      <label>&nbsp;</label>
                      <div class="lbl-info">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="isConsiderCustomerWaitingSlots" formControlName="isConsiderCustomerWaitingSlots"
                            (change)="onChangeConsiderCustomerWaitingSlots(mechanicInfo.isConsiderCustomerWaitingSlots)">
                          <label class="custom-control-label" for="isConsiderCustomerWaitingSlots" translate>lblConsiderCustomerWaitingSlots</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
            </form>
          </div>
        </div>
          <div class="modal-footer">
              <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                  <button type="submit" class="btn btn-primary mr-sm-2" [disabled]="addmechanicForm.invalid" (click)="AddMechanic()" translate
                      aria-label="Center Align"><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd</button>
                  <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" aria-label="Center Align"
                      translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</button>
              </div>
          </div>
        </ng-template>
      </div>
            <div class="p-3 bg-light pp-footer-top-brdr">
              <div class="d-flex flex-sm-row flex-column justify-content-end">
                  <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
              </div>
          </div>
          </div>
        </div>
    </div>
  </div>
</div>
